import Model from '../utils/Model'

class CustomerState {
  constructor(code, chineseName, englishName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'CustomerState'

export const NEW_CUSTOMER = new CustomerState(0, 'New', '新客户')
export const DEVELOPING_CUSTOMER = new CustomerState(1, 'Developing', '发展中客户')
export const OLD_CUSTOMER = new CustomerState(2, 'Old', '老客户')
export const LOST_CUSTOMER = new CustomerState(3, 'Lost', '丢失客户')

export const CUSTOMER_STATES = [NEW_CUSTOMER, DEVELOPING_CUSTOMER, OLD_CUSTOMER, LOST_CUSTOMER]

/**
 *  return null:没找到.
 */
export function getCustomerStateByCode(code) {
  return Model.getObjByCode(code, CUSTOMER_STATES)
}
